import hashSum from 'hash-sum';
import { Form } from 'informed';
import PropTypes from 'prop-types';
import { Fragment, useContext } from 'react';

import { ButtonGroup, ButtonSecondary, SubmitButton } from 'Buttons';
import { CustomCheckbox } from 'Forms';

import ModalContent from './ModalContent';
import ModalContext from './ModalContext';

// This component is deprecated in favor of the ModalConfirmationForm that is built into Phoebe

const ModalConfirmationForm = ({
  cancelButtonLabel,
  confirmationText,
  onSubmit,
  onDismiss,
  isWorking,
  submitButtonLabel,
  submitButtonType,
}) => {
  const { isScrollableHeight } = useContext(ModalContext);
  const checkboxField = hashSum(`modal-confirmation-${submitButtonLabel}`);
  return (
    <ModalContent
      className={`overflow-visible ${
        isScrollableHeight ? 'border-t border-solid border-gray-2' : ''
      }`}
    >
      <Form onSubmit={onSubmit}>
        {({ formState }) => (
          <Fragment>
            <fieldset>
              <legend className="sr-only">
                Confirmation Checkbox to Enable Action: {submitButtonLabel}
              </legend>
              <CustomCheckbox field={checkboxField}>
                {confirmationText}
              </CustomCheckbox>
            </fieldset>
            <ButtonGroup className="mt-2">
              <SubmitButton
                disabled={!formState.values[checkboxField]}
                isLoading={isWorking}
                type={submitButtonType}
              >
                {submitButtonLabel}
              </SubmitButton>
              {cancelButtonLabel && (
                <ButtonSecondary onClick={onDismiss}>
                  {cancelButtonLabel}
                </ButtonSecondary>
              )}
            </ButtonGroup>
          </Fragment>
        )}
      </Form>
    </ModalContent>
  );
};

ModalConfirmationForm.defaultProps = {
  cancelButtonLabel: '',
  isWorking: false,
  onDismiss: () => {},
  submitButtonType: 'danger',
};

ModalConfirmationForm.propTypes = {
  cancelButtonLabel: PropTypes.string,
  confirmationText: PropTypes.string.isRequired,
  isWorking: PropTypes.bool,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  submitButtonLabel: PropTypes.string.isRequired,
  submitButtonType: PropTypes.string,
};

export default ModalConfirmationForm;
